import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import FixedAssetBalanceFilters from "./components/FixedAssetBalanceFilters";
import FixedAssetBalanceTable from "./components/FixedAssetBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportFixedAssetBalanceCsv } from "./components/exportFixedAssetBalanceCsv";

const { Title } = Typography;

const FixedAssetBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, total_balance } = useSelector(  // ← added list, total_balance
    (state) => state.fixedAssetBalance
  );
  const reportRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Fixed Asset Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportFixedAssetBalanceCsv({
      list,
      total_balance,
      filters,
      title:    "Fixed Asset Balance Report",
      filename: "fixed_asset_balance_report",
    });
  };

  const hasData = list.length > 0; // ← added
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Fixed Asset Balance Report</Title>}
       extra={
            // ← replaced single Button with Flex + two buttons
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
        />

        <FixedAssetBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <FixedAssetBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Fixed Asset Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => <FixedAssetBalanceTable printMode={true} />}
        />
      </div>
    </div>
  );
};

export default FixedAssetBalance;
